import { fadeIn } from 'Assets/js/components/ossAnimations';
import jsUtils from '@pernod-ricard-global-cms/jsutils';
import Vue from 'vue';
import productAside from 'Templates/pages/productAside/productAside.vue';
import mobileAddToCartWrapper from 'Templates/pages/productAside/Wrapper/index.vue';
import addToWishlist from 'Templates/pages/productAside/Heading/addToWishlist.vue';
import Vuex from 'vuex';
import store from 'Assets/js/Vuex/Store/store';
import userInstance from 'Assets/js/Vuex/Store/stores/userInstance';
import cartInstance from 'Assets/js/Vuex/Store/stores/cartInstance';

export default function productaside() {
  try {
    import('Assets/scss/pages/product-aside.scss');
    const options = document.getElementById('productaside');

    if (options) {
      fadeIn(options);

      // eslint-disable-next-line import/no-dynamic-require
      jsUtils.loadCss(options.dataset.assetkey, options).then(() => {
        const mountElement = options.children[0];
        Vue.use(Vuex);
        const productAsideInstance = new Vue({
          name: 'ProductAside',
          data: { ...mountElement?.dataset, options },
          render: (h) => h(productAside),
          userInstance,
          cartInstance,
          store
        });

        const mounter = document.getElementById('productaside_add_to_cart');
        const mountAddToCart = mounter?.children[0];
        const mobileAddToCartInstance = new Vue({
          name: 'MobileAddToCartWrapper',
          data: { ...mountAddToCart?.dataset, options },
          render: (h) => h(mobileAddToCartWrapper),
          store
        });


        productAsideInstance.$mount(mountElement);

        // 90% sure we don't use this anymore. As new prodect aside is responsive.
        // Removing as it is loaded also on desktop and makesn a (duplicate) call to shopify.
        //mobileAddToCartInstance.$mount(mountAddToCart);

        if (window.grecaptcha) {
          // eslint-disable-next-line func-names
          window.ReCaptchaCallbackV3 = function () {
            window.grecaptcha.ready(() => {
              window.grecaptcha
                .execute(window.global_theme_object.recapcha_site_key)
                .then((token) => {
                  // Check if a form with recapatcha is available
                  const recaptchaResponse = document.getElementById(
                    'g-recaptcha-response'
                  );
                  if (recaptchaResponse) {
                    // Set token
                    recaptchaResponse.value = token;
                    // eslint-disable-next-line no-console
                    console.log('reCAPTCHA is set up.');
                  }
                });
            });
          };
          const reCAPTCHA = document.createElement('script');
          reCAPTCHA.src = `https://www.google.com/recaptcha/api.js?onload=ReCaptchaCallbackV3&render=${window.global_theme_object.recapcha_site_key}`;
          document.head.appendChild(reCAPTCHA);
        }
      });
    }

    const v1favourites = document.getElementById('productasidefavouriteV1');
    if (v1favourites) {
      const mountElement = v1favourites.children[0];
      Vue.use(Vuex);
      new Vue({
        name: 'ProductAsideFavouriteV1',
        data: { ...mountElement?.dataset, v1favourites },
        created() {
          if (!this.$store) {
            return;
          }
          window.addEventListener('updated_store', () => {
            this.$store.dispatch('userInit');
          });
          this.$store.dispatch('userInit').then(() => {
            this.$store.dispatch('setLoaded').then(() => {});
          });
        },
        store,
        userInstance,
        cartInstance,
        render: (h) => h(addToWishlist)
      }).$mount(mountElement);
    }
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error(error);
  }
}
